import React from 'react';
import {
  Typography,
  Box
} from '@mui/material';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip
} from 'recharts';
import { Card } from 'Components/Card'


const PieChartWithLegend = ({ title, data }) => {
  const total = data.reduce((acc, item) => acc + item.value, 0);

  return (
    <Card>
      <Typography variant="subtitle1" fontWeight="bold" className="mb-4">
        {title}
      </Typography>

      <Box display="flex" alignItems="center" justifyContent="space-between" >
        <ResponsiveContainer width={190} height={190}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={80}
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>

        <Box ml={10}>
          {data.map((item, index) => (
            <Box key={index} display="flex" alignItems="center" mb={1}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: item.color,
                  mr: 1
                }}
              />
              <Typography variant="body2" className="mr-2">{item.name}</Typography>
              <Typography
                variant="body2"
                sx={{
                  color: item.color,
                  fontWeight: 'bold',
                  ml: 'auto'
                }}
              >
                {((item.value / total) * 100).toFixed(1)}%
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

export default PieChartWithLegend;
